import React from "react";

const Status = props => {

  return (
    <table className="status-table" cellSpacing="4" cellPadding="4">
      <tbody>
        <tr>
          <td> Correct:   <span className="status-correct">   {props.correct.toString()}   </span></td>
          <td> Incorrect: <span className="status-incorrect"> {props.incorrect.toString()} </span></td>
          <td> Remaining: <span className="status-remaining"> {props.remaining.toString()} </span></td>
        </tr>
      </tbody>
    </table>
  );

}

export default Status;

